/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React, { useEffect, useState } from 'react';
import { Utils } from 'Utils/utils';
import { observer } from 'mobx-react';
import { Link, withRouter } from 'react-router-dom';
import userDetail from 'Stores/userDetail';
import companySearchState from 'Stores/companySearch';
import { CreateNewList } from 'Components/common/createNewList';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import { LoadingWrapper } from 'Components/common/loadingWrapper';
import Button from 'Components/common/Button';
import { advSearchState } from 'Stores/advSearch';
import { freeTrialPopupState } from 'Stores/freeTrialPopupState';
import * as CONSTANTS from 'Utils/constants';
import { suppressionListUploadState } from 'Components/common/suppressionListUploadPopup';
import { ReactComponent as BellIcon } from 'Assets/svg/notification-bell-new.svg';
import { ReactComponent as ContactIcon } from 'Assets/svg/empty-new-contacts.svg';
import { ExportLeads } from 'Components/common/ExportLeads/exportLeads';
import AsyncPurchaseExportMsgPopupComponent from 'Components/common/ExportLeads/asyncExportPopup';
import Pagination from 'Components/common/pagination';
import { paygPurchaseMorePopupState } from 'Components/common/paygPurchaseMorePopup';
import { ReactComponent as NewSearchImg } from 'Assets/svg/new-search-img.svg';
import EmptySearch from 'Assets/png/empty-search-results.png';
import advSearchFiltersState from 'Stores/advSearchFilters';
import { FIlterFacets } from './filterFacets/filterFacets';
import { AppliedFilters } from './appliedFilters';
import { ContactList } from './searchList/contactList';
import { ContactMiddleSection } from './contactMiddleSection';
import { contactFilterPopupState } from './filterFacets/contactFilterPopup';
import { SyncPurchaseInfoPopup } from './syncPurchaseInfoPopup';
import LimitReachedPopUp from './savedSearch/limitReachedPopUp';
import SavedSearchPopUp from './savedSearch/savedSearchPopUp';
import { AddToListWithOptions } from './AddToListWithOptions';
import SalesforceAuthErrorPopup from './SalesforceAuthErrorPopup';

const { FREE_TRIAL_POPUP_TRIGGERS } = CONSTANTS;
const {
  SINGLE_VIEW_CONTACTS,
  WEBSITE_VIEW_CONTACTS,
} = FREE_TRIAL_POPUP_TRIGGERS;

// const NoResultsFound = props => {
//   const { currentTab } = props;
//   // eslint-disable-next-line react/style-prop-object
//   return (
//     <div className="no-results-wrap">
//       <NewSearchImg />
//       <div className="no-results-text">
//         We did not find{' '}
//         <span>{currentTab === 'contact' ? 'contacts' : 'companies'}</span> that
//         match your search criteria. <br /> Please revise your search criteria
//       </div>
//     </div>
//   );
// };

const NoResultsFoundForSavedSearch = props => {
  const { setShowPopup } = props;
  return (
    <div className="no-results-wrap saved-search">
      <img src={EmptySearch} alt="Empty results illustration" />
      <div className="no-results-title">
        We couldn&#39;t find any contacts that match your search.
      </div>
      <div className="message">
        Save your search and sit back! We’ve put our data team to the task. Get
        notified as soon we add new contacts that match your search.
      </div>
      <Button
        btnText="Save Search"
        click={() => {
          Utils.mixpanelTrack(
            CONSTANTS.MX_SAVED_SEARCH_EVENTS.EMPTY_RESULTS_SAVE_SEARCH_CLICK,
          );
          setShowPopup(true);
        }}
      />
    </div>
  );
};

const ProvideOneMoreCriteria = () => {
  // eslint-disable-next-line react/style-prop-object
  return (
    <div className="no-results-wrap">
      <NewSearchImg />
      <div className="no-results-text">
        Please select at least one more search criteria
      </div>
    </div>
  );
};

const EmptySearchCriteria = observer(props => {
  const { setSavedSearchId } = props;
  const localCurrIndustrySearch = Utils.getLocalStorage('showIndustrySearch');
  const [contactSavedSearch, setContactSavedSearch] = useState([]);
  useEffect(() => {
    if (userDetail.contactSavedSearches.length > 3)
      setContactSavedSearch(userDetail.contactSavedSearches.slice(0, 3));
    else setContactSavedSearch(userDetail.contactSavedSearches);
  }, [userDetail.contactSavedSearches]);

  const showAll = () => {
    Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_VIEW_ALL_FILTERS_CLICKED, {
      btnSource: 'No search section',
    });
    if (localCurrIndustrySearch !== null)
      Utils.setLocalStorage('popupIndustrySearch', localCurrIndustrySearch);
    else Utils.removeLocalStorage('popupIndustrySearch');
    contactFilterPopupState.setShowPopup(true);
  };
  // eslint-disable-next-line react/style-prop-object
  return (
    <div className="no-results-wrap">
      <NewSearchImg />
      <div className="no-results-text">
        {`Provide your search criteria and find your contacts from over ${CONSTANTS.CONTACT_COUNT_IN_MILLIONS}
        business contacts`}
      </div>
      <div className="adv-saved-searches-wrap">
        {userDetail.contactSavedSearches.length > 0 ? (
          <>
            <h5 className="save-search-header">Recently Saved Searches</h5>
            <div className="adv-saved-searches">
              <div className="header-container">
                <span>Name</span>
                <span>Created Date</span>
              </div>
              <div className="adv-saved-searches-container">
                {contactSavedSearch.length > 0 &&
                  contactSavedSearch?.map((savedSearch, index) => {
                    const {
                      creationTimeStamp,
                      templateName,
                      searchTemplate,
                      id,
                    } = savedSearch;
                    const searchJson = JSON.parse(searchTemplate);

                    return (
                      <div
                        className="saved-search-list"
                        key={id}
                        onClick={() => {
                          if (window.location.hash === '#search')
                            window.history.replaceState(
                              null,
                              null,
                              `${window.location.pathname}`,
                            );
                          setSavedSearchId(id);
                          advSearchState.applySearch(searchJson);
                          Utils.mixpanelTrack(
                            CONSTANTS.MX_SAVED_SEARCH_EVENTS
                              .CLICK_LOAD_SAVED_SEARCH_AS_PAGE,
                            {
                              id,
                              name: templateName,
                            },
                          );
                        }}
                      >
                        <div className="inner-wrap">
                          <span className="show-elipsis">
                            <span
                              className="saved-search-list-name"
                              title={templateName}
                            >
                              {templateName}
                            </span>
                          </span>
                          <span className="saved-search-list-time">
                            {Utils.getFormattedDate(creationTimeStamp, true)}
                          </span>
                        </div>
                      </div>
                    );
                  })}

                <Link
                  to={'/advanced-search/contact/saved-searches'}
                  className="saved-search-link"
                  onClick={() => {
                    Utils.mixpanelTrack(
                      CONSTANTS.MX_SAVED_SEARCH_EVENTS.CLICK_SHOW_ALL_SEARCHES,
                      { count: userDetail.contactSavedSearches.length },
                    );
                  }}
                >
                  <div className="save-searches-btn">
                    {userDetail.contactSavedSearches.length > 4
                      ? `Show all ${userDetail.contactSavedSearches.length} saved
                    searches`
                      : 'Go to saved searches'}
                  </div>
                </Link>
              </div>
            </div>
          </>
        ) : (
          <Link
            to={'/advanced-search/contact/saved-searches'}
            className="saved-search-link"
            onClick={() => {
              Utils.mixpanelTrack(
                CONSTANTS.MX_SAVED_SEARCH_EVENTS.CLICK_SHOW_ALL_SEARCHES,
                { count: userDetail.contactSavedSearches.length },
              );
            }}
          >
            <div className="save-searches-btn">Go to saved searches</div>
          </Link>
        )}
      </div>
    </div>
  );
});

const ResultSection = observer(props => {
  const {
    contactId,
    setContactId,
    currentTab = 'contact',
    setShowPopup,
    savedSearchId,
    history,
  } = props;

  let currentSelectedState;
  if (currentTab === 'contact') currentSelectedState = advSearchState;
  else currentSelectedState = companySearchState;
  // console.log('ResultSection ', !currentSelectedState.searchLoading);
  // debugger;
  if (!currentSelectedState.resultLoading) {
    // console.log('ResultSection ', !currentSelectedState.searchLoading);
    if (currentSelectedState.resultStatusMsg === 'empty')
      return <EmptySearchCriteria {...props} />;
    if (currentSelectedState.resultStatusMsg === 'one_more')
      return <ProvideOneMoreCriteria currentTab={currentTab} />;
    if (currentSelectedState.searchResults.length > 0)
      return (
        <ContactList
          data={currentSelectedState.searchResults}
          allChecked={currentSelectedState.allContactSelected}
          contactId={contactId}
          setContactId={setContactId}
          savedSearchId={savedSearchId}
          setShowPopup={setShowPopup}
          history={history}
        />
      );
    if (savedSearchId !== '' && currentSelectedState.searchResults.length === 0)
      return (
        <div className="contact-list no-results">
          <div className="no-updates-wrapper">
            <ContactIcon />
            <div className="no-data-text">
              You do not have any new set of contacts. But don&#39;t forget to
              check it out later, as we are constantly enhancing our contacts
              data.
            </div>
          </div>
        </div>
      );
    // if (Utils.isSavedSearchUpdateEnabled())
    return <NoResultsFoundForSavedSearch setShowPopup={setShowPopup} />;
    // return <NoResultsFound currentTab={currentTab} />;
  }
  return '';

  // return advSearchState.resultLoading ? '' : <NoResultsFound />;
});

const AdvancedSearchWrap = observer(props => {
  const [contactId, setContactId] = React.useState('');
  const [showPopup, setShowPopup] = useState(false);
  const { match, history } = props;
  const { params, path } = match;
  const { savedTemplete = '' } = params;

  const companyDomain = Utils.getQueryParamFromUrl(
    'companyDomain',
    window.location.href,
  );
  const trigger = Utils.getProspectorUserTrigger(window.location.href);
  Utils.setLocalStorage('companySearch', false);

  const currentTab = 'contact';
  userDetail.setCurrentTab(currentTab);

  // for showing in UI alone
  const [newContactInDays, setNewContactInDays] = React.useState(null);
  const [savedSearchId, setSavedSearchId] = React.useState('');
  const [isCreateSearchLoading, setIsCreateSearchLoading] = React.useState(
    false,
  );

  const [limitReachedPopupData, setLimitReachedPopupData] = React.useState({
    show: false,
    data: {},
  });

  const afterLogginCheckFlow = () => {
    if (trigger !== null) {
      freeTrialPopupState.setDynamicText(companyDomain);
      freeTrialPopupState.setFreeTrialPrePopup(trigger);

      window.history.replaceState(
        null,
        null,
        '/advanced-search/contact#search',
      );
    }
    if (
      trigger === 'single-view-contacts' ||
      trigger === 'website-view-contacts'
    ) {
      advSearchState.checkBoxFilters.showContactsWithoutEmail = true;
      advSearchState.checkBoxFilters.showContactsWithEmail = true;
    }

    if (companyDomain !== null)
      advSearchState.domainSearchFilter(companyDomain);

    if (savedTemplete !== '' && userDetail.contactSavedSearches.length > 0) {
      let searchTempletePostdata = {};
      for (let i = 0; i < userDetail.contactSavedSearches.length; i += 1)
        if (userDetail.contactSavedSearches[i].id === savedTemplete) {
          searchTempletePostdata =
            userDetail.contactSavedSearches[i].searchTemplate;

          setSavedSearchId(userDetail.contactSavedSearches[i].id);
          break;
        }

      const searchJson = JSON.parse(searchTempletePostdata);
      if (searchJson.limit !== undefined && searchJson.limit > 100)
        searchJson.limit = 50;
      const newSelectedTab =
        Utils.getQueryParamFromUrl('tab', window.location.href) || 1;

      const modifiedSearchJson = advSearchState.checkAndAddEmailStatus(
        searchJson,
        true,
      );
      if (
        parseInt(newSelectedTab, 10) === 2 &&
        userDetail.isContactUpdatesEnabled
      ) {
        const noOfDays =
          Utils.getQueryParamFromUrl('createdInDays', window.location.href) ||
          30;
        setNewContactInDays(noOfDays);
        advSearchState.applySearch({
          ...modifiedSearchJson,
          createdInLastNoOfDays: parseInt(noOfDays, 10),
        });
      } else {
        advSearchState.applySearch(modifiedSearchJson);
      }

      Utils.setLocalStorage('companySearch', false);
      window.history.replaceState(null, null, '/advanced-search/contact');
    } else {
      advSearchState.retainSearch();
    }
  };

  useEffect(() => {
    if (window.location.hash) {
      setSavedSearchId('');
      setNewContactInDays(null);
    }
  }, [advSearchState.appliedFilterPostData]);

  useEffect(() => {
    // After login check - flow
    if (
      userDetail.onFirstLoad &&
      suppressionListUploadState.suppressionListLoaded
    )
      afterLogginCheckFlow();
  }, [
    userDetail.onFirstLoad,
    suppressionListUploadState.suppressionListLoaded,
  ]);

  useEffect(() => {
    advSearchFiltersState.fetchFilterValues();

    return () => {
      setNewContactInDays(null);
      advSearchState.searchResults = [];
      advSearchState.searchResultCount = 0;
      advSearchState.uniqueCompanyCount = 0;
    };
  }, []);

  const hideSuggestionOnMouseLeave = e => {
    if (
      document &&
      document.querySelectorAll('.filter-parents .suggestion-mask').length > 0
    ) {
      document.querySelectorAll('.filter-parents .suggestion-mask')[0].click();
      document.activeElement.blur();
    }
  };

  const changePage = (pageNo, opr) => {
    if (
      advSearchState.selectedAllContactAcrossPage ||
      advSearchState.selectedContactFromRange
    ) {
      const deselectCallback = () => {
        advSearchState.clearAllSelection();
        advSearchState.updateSelectedBulkContactAll(true);
      };
      confirmationPopupState.setPopupValues({
        title: 'Unable to deselect',
        content:
          'Unable to deselect individual items while using "Select all or Range selection". To deselect an item, clear the selection and select items individually.',
        actionBtnText: 'Clear selection',
        callback: deselectCallback,
      });
      confirmationPopupState.setShowPopup(true);
    } else {
      advSearchState.setCurrentPage(pageNo, opr);
    }
  };

  const changePageLimit = val => {
    advSearchState.setPageLimit(val);
  };

  const handleSaveSearchCallback = (status, data) => {
    if (status === 'limit') setLimitReachedPopupData({ show: true, data });
  };

  const createSavedSearch = async data => {
    const newData = data;
    let newSavedSearchId;
    setIsCreateSearchLoading(true);
    if (data.id === undefined) {
      if (data.status === undefined) newData.status = 'INACTIVE';
      newSavedSearchId = await advSearchState.saveSearch(newData, {
        callback: handleSaveSearchCallback,
      });
    } else {
      const savedSearchToUpdate = userDetail.contactSavedSearches?.find(
        savedSearch => savedSearch.id === data.id,
      );
      const { id } = savedSearchToUpdate;
      const { templateName, ...remainingProps } = data;
      const isEmailScheduleUpdated = Object.keys(remainingProps).some(
        key => remainingProps[key] !== savedSearchToUpdate[key],
      );
      newSavedSearchId = id;
      const success = await advSearchState.updateSavedSearch({
        id,
        searchTemplate: JSON.stringify(advSearchState.appliedFilterPostData),
        templateName,
        ...(isEmailScheduleUpdated
          ? { ...remainingProps }
          : remainingProps.frequency
          ? {}
          : {
              status: 'INACTIVE',
            }),
      });
      if (success)
        Utils.mixpanelTrack(
          CONSTANTS.MX_SAVED_SEARCH_EVENTS.REPLACE_SAVED_SEARCH,
          {
            name: templateName,
            searchCriteria: advSearchState.appliedFilterPostData,
            ...remainingProps,
          },
        );
    }
    setIsCreateSearchLoading(false);
    setSavedSearchId(newSavedSearchId);
    setShowPopup(false);
    if (window.location.hash === '#search')
      window.history.replaceState(null, null, `${window.location.pathname}`);
  };

  return (
    <div className="search-results contact-search">
      <LimitReachedPopUp
        history={history}
        open={limitReachedPopupData.show}
        data={limitReachedPopupData.data}
        onClose={() => {
          setLimitReachedPopupData({ show: false, data: {} });
        }}
      />
      <div className="left-section">
        <div className="page-title">
          <div className="page-title-text">Contacts Search</div>
          {advSearchState.searchResultCount > 0 &&
            Object.keys(advSearchState.appliedFilterPostData).length > 0 && (
              <span
                className="save-search-button"
                onClick={() => {
                  setShowPopup(true);
                }}
              >
                <BellIcon className="bell-icon" />
                <span>Save Search</span>
              </span>
            )}
        </div>
        <div
          className={`filter-container${
            currentTab === 'contact'
              ? ' contact-filter-container'
              : ' company-filter-container'
          }`}
          onMouseLeave={e => hideSuggestionOnMouseLeave(e)}
        >
          <FIlterFacets currentTab={currentTab} />
        </div>
      </div>
      <div className="right-section">
        <AppliedFilters currentTab={currentTab} />
        {(advSearchState.searchResultCount > 0 ||
          (savedSearchId !== '' &&
            advSearchState.searchResults.length === 0)) && (
          <ContactMiddleSection
            newContactInDays={newContactInDays}
            setNewContactInDays={setNewContactInDays}
            isResultLoading={advSearchState.resultLoading}
            contactId={contactId}
            setContactId={setContactId}
            savedSearchId={savedSearchId}
            selectedTab={
              Object.keys(advSearchState.appliedFilterPostData).includes(
                'createdInLastNoOfDays',
              )
                ? 2
                : 1
            }
          />
        )}
        <ResultSection
          currentTab={currentTab}
          contactId={contactId}
          setContactId={setContactId}
          savedSearchId={savedSearchId}
          setSavedSearchId={setSavedSearchId}
          setShowPopup={setShowPopup}
          {...props}
        />
        {advSearchState.resultLoading && (
          <ContactList
            isListLoading
            data={[]}
            allChecked={false}
            contactId=""
            setContactId={setContactId}
          />
        )}
        {advSearchState.searchResultCount > 0 && (
          <Pagination
            totalCount={advSearchState.searchResultCount}
            rowsPerPage={advSearchState.pageLimit}
            currentPage={advSearchState.currentPage + 1}
            updateCurrentPage={changePage}
            onRowsPerPageUpdate={changePageLimit}
            pageName="advSearchContact"
            showTotalLogs={false}
          />
        )}
      </div>
      <ExportLeads enabledExportTypes={['Salesforce', 'Hubspot']} />
      <CreateNewList />
      <LoadingWrapper
        className="advanced-search-page-loader"
        show={
          advSearchState.actionLoader ||
          paygPurchaseMorePopupState.paygCheckLoader
        }
        position="fixed"
      />
      {showPopup && (
        <SavedSearchPopUp
          isAPILoading={isCreateSearchLoading}
          onSubmit={createSavedSearch}
          onClose={() => setShowPopup(false)}
        />
      )}
      <AsyncPurchaseExportMsgPopupComponent />
      <SyncPurchaseInfoPopup />
      <AddToListWithOptions />
      <SalesforceAuthErrorPopup />
    </div>
  );
});

const AdvancedSearch = observer(props => {
  Utils.stopBodyScroll();

  return (
    <>
      <AdvancedSearchWrap {...props} />
    </>
  );
});

export default withRouter(AdvancedSearch);
